// extracted by mini-css-extract-plugin
export var icon = "_wu-0";